import { cn } from '@/lib/utils'
import React from 'react'

export default function StepHeading({ className, ...props }) {
  return (
    <h3
      className={cn(['pb-5 font-bold text-txt-secondary tablet:pb-8'], className)}
      {...props}
    ></h3>
  )
}
